import React, { useState } from 'react';
import {
  about,
  about1,
  about2,
  about3,
  care1,
  care10,
  care11,
  care2,
  care3,
  care4,
  care5,
  care6,
  care7,
  care8,
  care9,
  flag1,
  flag2,
  flag3,
  flag4,
  flag5,
  flag6,
  logoAbout,
  opportunity1,
  opportunity2,
  opportunity3,
  opportunity4,
  partners1,
  partners2,
  partners3,
  partners4,
  partners5,
  product1,
  product2,
  product3,
  product4,
  sertifikat1,
  sertifikat2,
  sertifikat3,
  sertifikat4,
  sertifikat5,
  sertifikat6,
  service1,
  service2,
  service3,
  service4,
  service5,
  service6,
  why1,
  why2,
  why3,
  why4,
  why5,
  why6,
  why7,
  why8,
  why9
} from '../../assets/images';
import { useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';

const care = [
  { id: 1, image: care1,  title: "Plastik Cərrahiyə", description: "Burun estetikası, bədən formalaşdırma, üz gərmə, gözaltı cərrahiyə, liposaksiya, mamoplastika və s. prosedurlar. İstədiyiniz görünüşü əldə etmək üçün ən müasir texnologiyalarla həyata keçirilən əməliyyatlar." },
  { id: 2, image: care2, title: "Bariatrik Cərrahiyyə", description: "Artıq çəkidən qurtulmaq və sağlam həyat tərzinə keçmək üçün Qastrik Bypass, Qastrik Sleev, Gastroplastika və digər müasir cərrahiyə həlləri. Bu əməliyyatlar, sağlamlıq problemini həll edərək həyat keyfiyyətini artırmaq məqsədi ilə həyata keçirilir." },
  { id: 3, image: care3, title: "Kardioloji Cərrahiyyə", description: "Ürək xəstəliklərinin müalicəsi üçün Bypass əməliyyatları, Qapalı ürək əməliyyatları, Koronaroangioplastika və digər metodlar." },
  { id: 4, image: care4, title: "Ortopedik Cərrahiyyə", description: "Sümüklər, əzələlər və oynaqların müalicəsi üçün Artroskopik əməliyyatlar, Sümük törəmələri, Protezlər və digər müasir texnologiyalarla həyata keçirilən əməliyyatlar." },
  { id: 5, image: care5, title: "Nevroloji Cərrahiyyə", description: "Beyin və onurğa iliyi xəstəliklərinin müalicəsi üçün Beyin şişləri əməliyyatları, Onurğa əməliyyatları, Sinir sıxılmalarının müalicəsi" },
  { id: 6, image: care6, title: "Estetik Dermatologiya və Cərrahiyyə", description: "Dəri problemləri, akne izləri, cərrahi müdaxilələrlə dərinin yenilənməsi, botoks, dolğu və s. prosedurlar." },
  { id: 7, image: care7,  title: "Ginekoloji Cərrahiyyə", description: "Dəri problemləri, akne izləri, cərrahi müdaxilələrlə dərinin yenilənməsi, botoks, dolğu və s. prosedurlar." },
  { id: 8, image: care8, title: "Urologiya Cərrahiyyə", description: "Laparoskopik əməliyyatlar, Uterus əməliyyatları, Histerektomiya, və digər ginekoloji müalicə və əməliyyatlar." },
  { id: 9, image: care9, title: "Onkoloji Cərrahiyyə", description: "Onkoloji xəstəlikləri ilə bağlı əməliyyatlar, Kimyaterapiya öncəsi və sonrakı əməliyyatlar, Dəri xərçəngi müalicəsi və digər müalicə variantları." },
  { id: 10, image: care10, title: "Oftalmoloji Cərrahiyyə", description: "Göz xəstəliklərinin müalicəsi üçün Katarakt əməliyyatları, Refraktiv cərrahiyyə, Retina əməliyyatları və digər müasir göz əməliyyatları." },
  { id: 11, image: care11, title: "Stomatoloji Cərrahiyyə", description: "Sağlam və Gözəl Dişlərə Yolu Açın. Diş cərrahiyyəsi, diş və ağız sağlamlığını qorumaq və estetik problemləri aradan qaldırmaq məqsədilə həyata keçirilən əməliyyatları əhatə edir. Bu sahədə ən çox tətbiq olunan əməliyyatlar arasında Diş İmplantasiyası, Diş Ağız Cərrahiyyəsi, Ortodontik Cərrahiyyə və Diş Ağartma kimi prosedurlar yer alır." }
];

const Care = () => {
  const { t } = useTranslation();
    const [activeIndex, setActiveIndex] = useState(0);
    const [showText, setShowText] = useState(false);
    const [showButton, setShowButton] = useState(false);
      const flags = [flag1, flag2, flag3, flag4, flag5, flag6];
      const partners = [partners1, partners2, partners3, partners4, partners5];


  return (

     <div className="md:max-w-container max-w-containerSm mx-auto mt-[24px] md:mt-[56px]">
          <p >{t("Ana səhifə")} <i className={`fas fa-chevron-right text-[black] ml-3 mr-3`}/> {t("Müalicə və prosedurlar")}</p>
          <div>
          <div className="max-w-container mx-auto mt-[24px] md:mt-[56px] ">
      <div className="flex items-center justify-between">
        <p className="text-3xl md:text-[46px] font-medium mx-auto">{t("Müalicə və prosedurlar")}</p>
      </div>
      <div className="grid grid-cols-1 mt-10 gap-10">
        {care.map((item) => (
          <div key={item.id} className="rounded-[12px] w-full md:h-[314px] border-[1px] border-[#388E3C] bg-white md:flex">
           <div className='md:mr-8 md:h-[314px] md:w-[305px]'>
           <img className="md:h-[314px] md:w-[305px] w-full rounded-t-[12px] md:rounded-t-none md:rounded-l-[12px]" src={item.image} alt="Opportunity" />
           </div>
            <div className='md:w-[924px] p-3'>
              <p className="mt-[12px] text-3xl md:text-[50px] font-medium md:font-semibold md:leading-[50px] ">{t(item.title)}</p>
              <p className="mt-[12px] md:text-3xl text-xl">
      {t(item.description)}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
          </div>
         
        </div>
  );
};

export default Care;